import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable, firstValueFrom } from "rxjs";
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TableTransactionsReservaService {

  // @ts-ignore
  private _products$ = new BehaviorSubject<table[]>([]);
  private _total$ = new BehaviorSubject<number>(0);
  get products$() { return this._products$.asObservable(); }
  get total$() { return this._total$.asObservable(); }
  page = 1;
  pageSize = 10

  constructor(private http: HttpClient, private authService: AuthService) {
  }

  private url(path: string): string {
    const base = this.authService.getOriginCurrency() !== 'BRL'
      ? environment.intlUrl
      : environment.apiUrl;
    return `${base}${path}`;
  }

  private baseByCurrency(originCurrency?: string): string {
    const iso = (originCurrency || '').trim().toUpperCase();
    const isIntl = iso !== '' && iso !== 'BRL';
    return isIntl ? environment.intlUrl : environment.apiUrl;
  }

  getReceiptTemplate(): Observable<string> {
    return this.http.get('/assets/templates/HtmlComprovantePix.html', { responseType: 'text' });
  }

  getBankProvider(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/bankProvider`)
  }

  getAccount(): Promise<any> {
    return firstValueFrom(this.http.get(`${environment.apiUrl}/account`));
  }

  getTransactionDetail(id: string, originCurrency: string): Promise<any> {
    const base = this.baseByCurrency(originCurrency);
    return firstValueFrom(
      this.http.get(`${base}/gettransactiondetail`, { params: { id } })
    );
  }

  resendWebhook(ids: string[], originCurrency: string): Promise<any> {
    const base = this.baseByCurrency(originCurrency);
    return firstValueFrom(
      this.http.post(`${base}/webhook/reprocess`, { transactionIds: ids })
    );
  }

}
